export default "__VITE_ASSET__1eef53b9__"